import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { Button } from '../ui/Button';
const bonuses = [{
  icon: '⚡',
  title: 'Menú Express 15 Días',
  desc: '15 días de comidas ya decididas',
  value: '$8.500'
}, {
  icon: '🍽️',
  title: 'Comidas Salvavidas',
  desc: '50+ ideas para días caóticos',
  value: '$7.500'
}, {
  icon: '🧮',
  title: 'Combinaciones Infalibles',
  desc: '50 combinaciones listas para copiar',
  value: '$6.500'
}, {
  icon: '✅',
  title: 'Checklist de Cocina',
  desc: 'Heladera y alacena siempre organizadas',
  value: '$6.000'
}, {
  icon: '🍳',
  title: 'Recetas Base',
  desc: 'Cocinás una vez, resolvés varios días',
  value: '$7.000'
}];
export const BonusesSection = () => {
  return <section className="py-16 px-4 bg-black" data-id="element-25">
      <div className="max-w-4xl mx-auto" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-27">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-500/20 rounded-full mb-4" data-id="element-28">
            <Gift className="w-8 h-8 text-orange-500" data-id="element-29" />
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-30">
            🎁 5 BONOS GRATIS CON TU COMPRA
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto rounded-full" data-id="element-31"></div>
        </motion.div>

        <div className="overflow-x-auto pb-4 mb-8" data-id="element-32">
          <div className="min-w-[700px] w-full bg-gray-900 rounded-xl border border-orange-500/30 overflow-hidden" data-id="element-33">
            <div className="grid grid-cols-12 gap-4 p-4 bg-black border-b border-orange-500/30 font-bold text-orange-500 uppercase tracking-wider text-sm" data-id="element-34">
              <div className="col-span-5" data-id="element-35">Bono</div>
              <div className="col-span-5" data-id="element-36">Qué resuelve</div>
              <div className="col-span-2 text-right" data-id="element-37">Valor</div>
            </div>

            <div className="divide-y divide-gray-800" data-id="element-38">
              {bonuses.map((b, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="grid grid-cols-12 gap-4 p-4 items-center hover:bg-gray-800/50 transition-colors" data-id="element-39">
                  <div className="col-span-5 flex items-center gap-3" data-id="element-40">
                    <span className="text-2xl" data-id="element-41">{b.icon}</span>
                    <span className="text-white font-bold text-lg" data-id="element-42">
                      {b.title}
                    </span>
                  </div>
                  <div className="col-span-5 text-gray-300" data-id="element-43">{b.desc}</div>
                  <div className="col-span-2 text-right text-gray-400 line-through" data-id="element-44">
                    {b.value}
                  </div>
                </motion.div>)}
            </div>

            <div className="p-6 bg-orange-900/20 border-t border-orange-500 text-center" data-id="element-45">
              <p className="text-2xl font-bold text-white" data-id="element-46">
                Valor total de bonos:{' '}
                <span className="line-through text-gray-400 mr-2" data-id="element-47">$35.500</span>
                <span className="text-orange-500 uppercase text-3xl ml-2 block md:inline mt-2 md:mt-0" data-id="element-48">
                  Hoy GRATIS
                </span>
              </p>
            </div>
          </div>
        </div>
        <p className="text-center text-gray-500 text-sm mt-2 mb-10 md:hidden" data-id="element-49">
          ← Deslizá para ver tabla completa →
        </p>

        <div className="max-w-xl mx-auto text-center" data-id="element-50">
          <Button href="#comprar" data-id="element-51">
            🔥 SÍ, QUIERO RESOLVER MI COCINA HOY MISMO
          </Button>
          <p className="mt-3 text-orange-400 text-sm font-bold" data-id="element-52">
            Acceso inmediato + 5 bonos GRATIS · Te quedan minutos para
            aprovecharlo
          </p>
        </div>
      </div>
    </section>;
};